import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitCommitmentData = createSelector(
  [selectFinancialCockpitState],
  ({ commitmentData }) => commitmentData
)
